export default index => (a, b) => {
  const x = a[index].toLowerCase()
  const y = b[index].toLowerCase()

  if (x < y) {
    return -1
  }

  if (x > y) {
    return 1
  }

  return 0
}
